var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0104 12.73C17.6014 12.73 18.0804 12.2509 18.0804 11.66C18.0804 11.069 17.6014 10.59 17.0104 10.59C16.4195 10.59 15.9404 11.069 15.9404 11.66C15.9404 12.2509 16.4195 12.73 17.0104 12.73Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6V7.78998C19.75 7.75998 19.46 7.73999 19.15 7.73999H14.87C12.73 7.73999 12.02 8.45003 12.02 10.59V15.7H6C2.8 15.7 2 14.9 2 11.7V6C2 2.8 2.8 2 6 2H16C19.2 2 20 2.8 20 6Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.7V20",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.9H12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9502 20H12.0002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0095 12.73C17.6004 12.73 18.0794 12.2509 18.0794 11.66C18.0794 11.069 17.6004 10.59 17.0095 10.59C16.4185 10.59 15.9395 11.069 15.9395 11.66C15.9395 12.2509 16.4185 12.73 17.0095 12.73Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 7.78998C19.7495 7.75998 19.4595 7.73999 19.1495 7.73999H14.8695C12.7295 7.73999 12.0195 8.45003 12.0195 10.59V19.15C12.0195 21.29 12.7295 22 14.8695 22H19.1495C21.2895 22 21.9995 21.29 21.9995 19.15V10.59C21.9995 8.76003 21.4795 7.97998 19.9995 7.78998ZM17.0096 10.59C17.5996 10.59 18.0795 11.07 18.0795 11.66C18.0795 12.25 17.5996 12.73 17.0096 12.73C16.4196 12.73 15.9395 12.25 15.9395 11.66C15.9395 11.07 16.4196 10.59 17.0096 10.59ZM17.0096 19.15C15.8296 19.15 14.8695 18.19 14.8695 17.01C14.8695 16.52 15.0395 16.06 15.3195 15.7C15.7095 15.2 16.3196 14.87 17.0096 14.87C17.5496 14.87 18.0395 15.07 18.4095 15.39C18.8595 15.79 19.1495 16.37 19.1495 17.01C19.1495 18.19 18.1896 19.15 17.0096 19.15Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1491 17.01C19.1491 18.19 18.1892 19.15 17.0092 19.15C15.8292 19.15 14.8691 18.19 14.8691 17.01C14.8691 16.52 15.0392 16.06 15.3192 15.7C15.7092 15.2 16.3192 14.87 17.0092 14.87C17.5492 14.87 18.0391 15.07 18.4091 15.39C18.8591 15.79 19.1491 16.37 19.1491 17.01Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0095 12.73C17.6004 12.73 18.0794 12.2509 18.0794 11.66C18.0794 11.069 17.6004 10.59 17.0095 10.59C16.4185 10.59 15.9395 11.069 15.9395 11.66C15.9395 12.2509 16.4185 12.73 17.0095 12.73Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliance);
export default __webpack_public_path__ + "static/media/appliance.7eaa49e702ea9e7fad03deee05ecf4d5.svg";
export { ForwardRef as ReactComponent };